import React, { useContext } from "react";
import "./Welcome.scss";
import { mobile } from "../../Services/Agent";
import videoDesk from "../../static/compress/bg_desktop.mp4";
import videoMobile from "../../static/compress/bg_mobile.mp4";
import { AppContext } from "../../stores/application.store";
import Div100vh from 'react-div-100vh';
import { useRef } from "react";
import { useEffect } from "react";
import posterVideo from "../../static/Images/mobile/bg.png";
// import canvidControl from "canvid";
// import videoCanvas from 'video-canvas';

export default function Welcome() {
  // Application Store context
  let videoRefMobile = useRef(null);
  let videoTest = useRef(null);
  let videoRefDesktop = useRef(null);
  let { scroll, setScroll, loaded } = useContext(AppContext)
  const scrollToVideo = () => {
    // let videoSec = document.querySelector("#video_section");
    // videoSec.scrollIntoView({
    //   behavior: "smooth",
    //   block: "center",
    //   inline: "nearest",
    // });
    setScroll(scroll => scroll = 1)
  };



  useEffect(() => {
    if (!videoRefMobile || !videoRefDesktop) return;
    if (scroll != 0) {
      videoRefMobile.current.classList.add("autohider");
      videoRefDesktop.current.classList.add("autohider");
    } else {
      window.setTimeout(() => {
        try {
          videoRefMobile.current.classList.remove("autohider");
          videoRefDesktop.current.classList.remove("autohider");
        } catch (e) { }
      }, 250);

    }
  }, [scroll]);

  const isIpad = () => {
    var iDevices = [
      'iPad Simulator',
      // 'iPhone Simulator',
      // 'iPod Simulator',
      'iPad',
      'MacIntel',
      // 'iPhone',
      // 'iPod'
    ];

    if (!!navigator.platform)
      while (iDevices.length)
        if (navigator.platform === iDevices.pop())
          return true;

    if (window.navigator.userAgent.match(/iPhone/i))
      return true;

    return false;
  }


  const setVideo = () => {
    if (isIpad())
      return <video
        className="video_wrapper"
        width="100%"
        height="100%"
        playsInline
        autoPlay
        loop
        muted
        // controls
        preload="false"
        ref={videoRefDesktop}
      >
        <source src={"https://besttv227-hls-video-ynet.cdn.it.best-tv.com/0720/8e9763552e867baa7051f7f56e196365/master.m3u8"} type="application/x-mpegURL" />
        {/* <source src={videoDesk} type="video/mp4" /> */}
      </video>
    if (mobile())
      return <video
        className="video_wrapper"
        width="100%"
        height="100%"
        playsInline
        autoPlay
        loop
        muted
        // controls
        preload="false"
        ref={videoRefMobile}
      >
        <source src={"https://besttv227-hls-video-ynet.cdn.it.best-tv.com/0720/9d1421a72da81d344140f84c1bc1ccfe/master.m3u8"} type="application/x-mpegURL" />
        {/* <source src={videoMobile} type="video/mp4" /> */}
      </video>
    return <video
      className="video_wrapper"
      width="100%"
      height="100%"
      playsInline
      autoPlay
      loop
      muted
      // controls
      preload="false"
      ref={videoRefDesktop}
    >
      <source src={"https://besttv227-hls-video-ynet.cdn.it.best-tv.com/0720/8e9763552e867baa7051f7f56e196365/master.m3u8"} type="application/x-mpegURL" />
      {/* <source src={videoDesk} type="video/mp4" /> */}
    </video>
  }

  /*
bg_desktop_alon.mp4
https://besttv227-hls-video-ynet.cdn.it.best-tv.com/0720/8e9763552e867baa7051f7f56e196365/master.m3u8

bg_mobile_alon.mp4
https://besttv227-hls-video-ynet.cdn.it.best-tv.com/0720/9d1421a72da81d344140f84c1bc1ccfe/master.m3u8


  */
  // useEffect(() => {
  //   if (loaded) {
  //     if (videoRefDesktop.current) {
  //       window.videojs(videoRefDesktop.current);
  //       window.setTimeout(() => {
  //         window.document.querySelector("#" + videoRefDesktop.current.id).play().then(d => console.log(d)).catch(e => console.log(e));
  //       }, 150);
  //     }
  //     if (videoRefMobile.current) {
  //       window.videojs(videoRefMobile.current);
  //       window.setTimeout(() => {
  //         window.document.querySelector("#" + videoRefMobile.current.id).play().then(d => console.log(d)).catch(e => console.log(e));
  //       }, 150);
  //     }
  //   }

  // }, [loaded]);


  // useEffect(() => {
  //   var canvidControlCallback;
  //   canvidControlCallback = canvidControl({
  //     selector: '.video_wrapper',
  //     videos: {
  //       clip1: {
  //         src: './static/sprites/desktop/0001.png', frames: 32, cols:6, fps: 30, loops: 99, onEnd: function () {
  //           console.log('clip1 ended.');
  //         }
  //       },
  //     },
  //     width: window.screen.width,
  //     height: window.screen.height,
  //     loaded: function () {
  //       canvidControlCallback.play('clip1');
  //       // reverse playback
  //       // canvidControl.play('clip1', true);
  //     }
  //   });
  // }, []);
  return (
    // <Div100vh>
    <section className="welcome sec watch sec-1">
      {/* {loaded && setVideo()} */}
      <video
      ref={videoTest}
        className="video_wrapper autohider"
        width="100%"
        height="100%"
        playsInline
        autoPlay
        loop
        muted
        // controls
        preload="false"
        ref={videoRefMobile}
      >
        <source src={videoMobile} type="video/mp4" />
      </video>
      <video
        className="video_wrapper desktop autohider"
        width="100%"
        height="100%"
        playsInline
        autoPlay
        loop
        muted
        // controls
        preload="false"
        ref={videoRefDesktop}
      >
        <source src={videoDesk} type="video/mp4" />
      </video> 
      <div className="wel_wrapper">
        <div className="wel_title"></div>
        <div className="wel_text_wrapper">
          <div>
            <h2 className="wel_sub">ברוכים הבאים למטריקס:</h2>
            <h2 className="wel_sub">צעדים ראשונים בעולמות ה-VR</h2>
          </div>
          <div>
            <h4 className="wel_text">מציאות מדומה - איך מתחילים,</h4>
            <h4 className="wel_text">במה משחקים ומה הפסדתם עד עכשיו</h4>
            <h6 className="editor">עורכת: הגר בוחבוט</h6>
          </div>
        </div>
        <div className="wel_arrow" onClick={scrollToVideo}>
          <i className="fas fa-arrow-down"></i>
        </div>
        {/* <div className="wel_glow">
                    <div className="glow_wrapper">
                        <div className="left_lava lava"></div>
                        <div className="middle_lava lava"></div>
                        <div className="right_lava lava"></div>
                        <div className="left_icycle icycle"></div>
                        <div className="right_icycle icycle"></div>
                    </div>
                </div> */}
      </div>
    </section>
    //</Div100vh>
  );
}
